import { Component } from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {ModalNavPage} from "../modal-nav/modal-nav";
import {VorlageneditorInspectionpointDetailsNewReviewPage} from "../vorlageneditor-inspectionpoint-details-new-review/vorlageneditor-inspectionpoint-details-new-review";

/**
 * Generated class for the VorlageneditorInspectionpointDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-vorlageneditor-inspectionpoint-details',
  templateUrl: 'vorlageneditor-inspectionpoint-details.html',
})
export class VorlageneditorInspectionpointDetailsPage {

  public inspectionPoint: any = null;
  public isSystem: boolean = false;
  public canReorder: boolean = false;

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public navParams: NavParams,
              private modalNavPage: ModalNavPage) {
    this.inspectionPoint = this.navParams.get('inspectionPoint');
    this.isSystem = this.navParams.get('isSystem');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VorlageneditorInspectionpointDetailsPage');
  }

  public close(): void {
    this.modalNavPage.dismissModal({inspectionPoint: this.inspectionPoint});
  }

  public addNewInpsectionPointReview(): void {
    this.navCtrl.push(VorlageneditorInspectionpointDetailsNewReviewPage, {reviews: this.inspectionPoint.reviews, isSystem: this.isSystem, isNew: true});
  }

  public showReviewDetails(review): void {
    if(!this.isSystem){
      this.navCtrl.push(VorlageneditorInspectionpointDetailsNewReviewPage, {review: review, isSystem: this.isSystem, isNew: false});
    }
  }

  public delete(review: Object): void {
    this.inspectionPoint.reviews = this.inspectionPoint.reviews.filter((_review) => {
      return _review !== review;
    })
  }

  public reorderReviews(indexes): void {
    let review = this.inspectionPoint.reviews[indexes.from];
    this.inspectionPoint.reviews.splice(indexes.from, 1);
    this.inspectionPoint.reviews.splice(indexes.to, 0, review);
  }

}



// WEBPACK FOOTER //
// ./src/pages/vorlageneditor-inspectionpoint-details/vorlageneditor-inspectionpoint-details.ts